/*
 *    Copyright (c) 2018-2025, lengleng All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 * Redistributions in binary form must reproduce the above copyright
 * notice, this list of conditions and the following disclaimer in the
 * documentation and/or other materials provided with the distribution.
 * Neither the name of the pig4cloud.com developer nor the names of its
 * contributors may be used to endorse or promote products derived from
 * this software without specific prior written permission.
 * Author: lengleng (wangiegie@gmail.com)
 */

import request from '@/api/axios';

// 选中品牌修改
export function apiChangeBrand(params) {
  return request({
    url: '/user/massage/user/brand/zone/l_selectBrand',
    method: 'GET',
    params,
  });
}

// ip查询列表接口
export function visitRecordList(query) {
  return request({
    url: '/cust/cust/l_findVisitRecord',
    method: 'post',
    data: query,
  });
}

// ip导出接口
export function visitRecordExport(query) {
  return request({
    url: `/cust/cust/l_exportVisitRecord?startTime=${query.startTime}&endTime=${query.endTime}`,
    method: 'get',
  });
}

export function adminsList(query) {
  return request({
    url: '/api/admin/search',
    method: 'post',
    data: query,
  });
}

export function addObj(obj) {
  return request({
    url: '/api/user/search',
    method: 'post',
    data: obj,
  });
}

export function addadmin(obj) {
  return request({
    url: '/api/admin/add',
    method: 'post',
    data: obj,
  });
}

export function getObj(id) {
  return request({
    url: `/api/admin/user/${id}`,
    method: 'post',
  });
}

export function delObj(obj) {
  return request({
    // url: '/api/admin/user/' + id,
    url: '/api/user/delete',
    method: 'post',
    data: obj,
  });
}

export function deladmin(query) {
  return request({
    url: '/api/admin/delete',
    method: 'post',
    data: query,
  });
}

export function putObj(obj) {
  return request({
    url: '/api/admin/user',
    method: 'post',
    data: obj,
  });
}
export function updateadmin(obj) {
  return request({
    url: '/api/admin/update',
    method: 'post',
    data: obj,
  });
}

export function getDetails(obj) {
  return request({
    url: `/api/admin/user/details/${obj}`,
    method: 'post',
  });
}

export function remote(type) {
  return request({
    url: `/area/province/list${type}`,
    method: 'post',
  });
}
/*
获取区域树数据
 * @param obj
 */
export function getRegionalTree(obj) {
  return request({
    url: '/user/area/a_tree',
    method: 'get',
  });
}
/*
根据id获取区域列表
 * @param id, page
 */
export function getRegionalListById(id, page) {
  return request({
    url: `/area/a_listByGroupId?id=${id}&pageNum=${page.currentPage}&pageSize=${page.pageSize}`,
    method: 'get',
  });
}
/*
添加新区域分组
 * @param name
 */
export function addNewRegion(name) {
  return request({
    url: `/area/a_add?sgroupName=${name}`,
    method: 'post',
  });
}

/*
根据公司名查询人员列表
 * @param name, page
 */
export function getMemListByName(name, page) {
  return request({
    url: `/person/a_listByComName?comName=${name}&pageNum=${page.currentPage}&pageSize=${page.pageSize}`,
    method: 'get',
  });
}

/*
根据区域id删除区域
 * @param id
*/
export function removeRegionById(id) {
  return request({
    url: `/area/a_del?id=${id}`,
    method: 'get',
  });
}

/*
更新区域
 * @param obj
*/
export function updateRegion(obj) {
  return request({
    url: '/area/a_addComToArea',
    method: 'post',
    data: obj,
  });
}

/*
查询角色树
*/
export function getRolesTree() {
  return request({
    url: '/role/a_findAllRoleAndGroup',
    method: 'get',
  });
}

/*
  查询角色树
  * @param userName
  */
export function getComListByUsername(id) {
  return request({
    url: `/user/massage/user/company/p_findByUserId?name=${id}`,
    method: 'get',
  });
}

export function changeCombm(comBm) {
  return request({
    url: `/user/massage/user/l_selectComBm?comBm=${comBm}`,
    method: 'get',
  });
}
/*
查询功能权限
* @param id
*/
export function getFuncList(id) {
  return request({
    url: '/function/a_list?pageNum=1&pageSize=10',
    method: 'get',
  });
}

/**
  * 查询功能管理 菜单
  * @param page
  */
export function getmanagement(page) {
  return request({
    url: `/function/a_list?pageNum=${page.currentPage}&pageSize=${page.pageSize}`,
    method: 'get',
  });
}

/**
  * 删除功能管理 菜单
  * @param page
  */
export function removemanagement(id) {
  return request({
    url: `/function/a_del?id=${id}`,
    method: 'get',
  });
}

/**
  * 修改功能管理 菜单
  * @param editdata
  */
export function editmanagement(editdata) {
  return request({
    url: '/function/a_update',
    method: 'post',
    data: editdata,
  });
}

/**
  * 添加功能管理 菜单
  */
export function addmanagement(addData) {
  return request({
    url: '/function/a_add',
    method: 'post',
    data: addData,
  });
}

/** *
 * 获得业务员列表列表
 * @param param
 */
export function salemanList(param) {
  return request({
    url: '/user/saleman/l_list',
    method: 'post',
    data: param,
  });
}

/** *
 * 停用指定的业务员
 * @param id
 * @param disabled
 */
export function salemanDisabled(id, disabled) {
  return request({
    url: `/user/saleman/disabled?id=${id}&disabled=${disabled}`,
    method: 'post',
  });
}

/** *
 * 获取新通知信息
 *  * @param comBm
 */
export function getNewmessage(comBm) {
  return request({
    url: `/param/l_getMessageDialogInfo?companyBm=${comBm}`,
    method: 'get',
  });
}

/** *
 * 回复消息反馈
 *  * @param messageTalking
 */
export function replyMessReceive(data) {
  return request({
    url: '/param/suggestions/l_saveReply',
    method: 'post',
    data,
  });
}

/** *
 * 消息反馈查看回复
 *  * @param messageTalking
 */
export function getMessReceiveDetail(data) {
  return request({
    url: `/param/suggestions/l_view?pkid=${data}`,
    method: 'get',
  });
}

/** *
 * 消息反馈列表
 *  * @param
 */
export function getMessReceiveList(param) {
  return request({
    url: `/param/suggestions/l_findList?pageSize=${param.pageSize}&pageNum=${param.pageNum}&UserId=${param.userid}`,
    method: 'get',
  });
}

/** *
 * 删除反馈列表
 *  * @param
 */
export function delMessReceive(ids) {
  return request({
    url: `/param/suggestions/l_delete?ids=${ids}`,
    method: 'post',
  });
}

/** *
 * 退款进度更新
 *  * @param
 */
export function updateRefundProgress(userId) {
  return request({
    url: `/user/cust/l_dealRefund?swId=${userId}`,
    method: 'get',
  });
}

/** *
 * 修改密码
 *  * @param
 */
export function updatePassword(param) {
  return request({
    url: '/user/massage/user/l_updatePassword',
    method: 'post',
    data: param,
  });
}

/** *
 * 获取媒体图片
 *  * @param
 */
export function getMediaImg(param) {
  return request({
    url: `/param/admin/media/l_getHomeMediaPicList?pageNum=0&pageSize=0&spath=${param}`,
    method: 'get',
  });
}

/** *
 * 获取是否需要显示登陆验证
 *  * @param
 */
export function getLoginCheck() {
  return request({
    url: '/user/massage/user/p_checkGeetest',
    method: 'get',
  });
}

export function getGeetestCode() {
  return request({
    url: '/user/massage/user/p_geetest',
    method: 'get',
  });
}

// 订单列表作废tab触发退款通知清除
export function getDealRefund(param) {
  return request({
    url: `/user/cust/l_dealRefund?swId=${param}`,
    method: 'get',
  });
}

// 新意见反馈 列表
export function feedbackList(param) {
  return request({
    url: 'cust/cust/l_getFeedbackList',
    method: 'post',
    data: param,
  });
}

// 新意见反馈 管理员列表
export function feedbackListAdmin(param) {
  return request({
    url: 'cust/cust/a_getFeedbackListByAdmin',
    method: 'post',
    data: param,
  });
}

// 新意见反馈 商务角标
export function feedbackNum(param) {
  return request({
    url: `cust/fe/user/l_getFeedbackSuperscrip?searchKey=${param}`,
    method: 'get',
  });
}

// 新意见反馈 管理员角标
export function feedbackNumAdmin(param) {
  return request({
    url: 'cust/cust/a_getAdminFeedbackSuperscrip',
    method: 'post',
    data: param,
  });
}

// 新意见反馈 管理员功能模块
export function moduleList(param) {
  return request({
    url: `cust/fe/user/l_getFeedbackModule?type=${param}`,
    method: 'get',
  });
}

// 新意见反馈 提交
export function submitFeedback(param) {
  return request({
    url: 'cust/cust/l_insertFeedbackData',
    method: 'post',
    data: param,
  });
}

// 新意见反馈 电赞
export function toPrise(param) {
  return request({
    url: 'cust/cust/l_updateFeedbackPraise',
    method: 'post',
    data: param,
  });
}

// 新意见反馈 获取意见反馈下拉来源（意见反馈-后台管理员
export function getFeedbackSource() {
  return request({
    url: 'cust/cust/a_getFeedbackSource',
    method: 'get',
  });
}

// 新意见反馈 导出意见反馈列表（意见反馈-后台管理员）
export function exportFeedbackList(param) {
  return request({
    url: `cust/cust/a_exportFeedbackList?source=${param.source}&module=${param.module}&sgin=${param.sgin}&searchKey=${param.searchKey}&startTime=${param.startTime}&endTime=${param.endTime}`,
    method: 'get',
  });
}

// 新意见反馈 提交意见反馈数据（意见反馈-后台）
export function replyFeedback(param) {
  return request({
    url: '/cust/cust/a_insertFeedbackReply',
    method: 'post',
    data: param,
  });
}

// 新意见反馈 查看意见反馈回复信息（意见反馈-后台）
export function feedbackReplyList(param) {
  return request({
    url: `/cust/cust/l_getFeedbackDataReply?feedbackId=${param}`,
    method: 'get',
  });
}

// 购物车来源统计饼图
export function orderOriginStatistics(param) {
  return request({
    url: '/cart/admin/cart/source/l_pie',
    method: 'post',
    data: param,
  });
}
// 购物车来源统计折线图
export function orderOriginStatisticsLine(param) {
  return request({
    url: '/cart/admin/cart/source/l_chart',
    method: 'post',
    data: param,
  });
}

// 热词管理列表
export function hotKeyList(param) {
  return request({
    url: `${process.env.VUE_APP_PRODUCTURL}admin/keyword/manager/l_search`,
    method: 'post',
    data: param,
  });
}

// 热词管理新增
export function hotKeyAdd(param) {
  return request({
    url: `${process.env.VUE_APP_PRODUCTURL}admin/keyword/manager/l_add`,
    method: 'post',
    data: param,
  });
}

// 热词管理修改
export function hotKeyEdit(param) {
  return request({
    url: `${process.env.VUE_APP_PRODUCTURL}admin/keyword/manager/l_update`,
    method: 'post',
    data: param,
  });
}

// 热词管理删除
export function hotKeyDel(param) {
  return request({
    url: `${process.env.VUE_APP_PRODUCTURL}admin/keyword/manager/l_delete`,
    method: 'post',
    data: param,
  });
}

// 热词分析获取自定义
export function hotKeyZdy(param) {
  return request({
    url: `${process.env.VUE_APP_PRODUCTURL}admin/keyword/analyse/l_custom_search`,
    method: 'post',
    data: param,
  });
}

// 热词分析保存热词
export function hotKeySave(param) {
  return request({
    url: `${process.env.VUE_APP_PRODUCTURL}admin/keyword/analyse/l_add`,
    method: 'post',
    data: param,
  });
}

// 获取品牌权限id
export function getbrandID() {
  return request({
    url: '/user/user/l_getBrandPermissions',
    method: 'get',
  });
}
